import { useParams, Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import { projetos } from '../../../mocks/projetos';

export default function ProjetoDetailPage() {
  const { id } = useParams<{ id: string }>();
  const projeto = projetos.find((p) => p.id === id);

  if (!projeto) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-black mb-4">Projeto não encontrado</h1>
          <Link to="/projetos" className="text-gold-500 hover:underline">
                Voltar para projetos
              </Link>
            </div>
          </div>
        );
      }

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <section className="relative h-[60vh] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src={projeto.imagem}
              alt={projeto.nome}
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-black/40"></div>
          </div>
          <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-12 flex items-end pb-16">
            <div>
              <div className="mb-4">
                <span
                  className={`px-4 py-2 rounded-full text-sm font-medium backdrop-blur-md ${
                    projeto.status === 'Em construção'
                      ? 'bg-blue-500/80 text-white'
                      : projeto.status === 'Entregue'
                      ? 'bg-green-500/80 text-white'
                      : 'bg-gold-500/80 text-gray-900'
                  }`}
                >
                  {projeto.status}
                </span>
              </div>
              <h1 className="text-6xl font-bold text-white mb-4">{projeto.nome}</h1>
              <div className="flex items-center text-white text-xl">
                <i className="ri-map-pin-line mr-2"></i>
                <span>{projeto.localizacao}</span>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <h2 className="text-4xl font-bold text-black mb-6">Sobre o projeto</h2>
                <p className="text-xl text-gray-700 leading-relaxed mb-8">{projeto.detalhes}</p>

                <div className="bg-beige-50 rounded-2xl p-8 mb-8">
                  <h3 className="text-2xl font-bold text-black mb-6">Características</h3>
                  <div className="grid grid-cols-2 gap-6">
                    <div>
                      <div className="flex items-center mb-2">
                        <i className="ri-ruler-line text-2xl text-gold-500 mr-3"></i>
                        <span className="text-sm text-gray-600">Área construída</span>
                      </div>
                      <p className="text-2xl font-bold text-black">{projeto.areaConstruida}</p>
                    </div>
                    <div>
                      <div className="flex items-center mb-2">
                        <i className="ri-hotel-bed-line text-2xl text-gold-500 mr-3"></i>
                        <span className="text-sm text-gray-600">Quartos</span>
                      </div>
                      <p className="text-2xl font-bold text-black">{projeto.quartos}</p>
                    </div>
                    <div>
                      <div className="flex items-center mb-2">
                        <i className="ri-drop-line text-2xl text-gold-500 mr-3"></i>
                        <span className="text-sm text-gray-600">Banheiros</span>
                      </div>
                      <p className="text-2xl font-bold text-black">{projeto.banheiros}</p>
                    </div>
                    <div>
                      <div className="flex items-center mb-2">
                        <i className="ri-car-line text-2xl text-gold-500 mr-3"></i>
                        <span className="text-sm text-gray-600">Vagas</span>
                      </div>
                      <p className="text-2xl font-bold text-black">{projeto.vagas}</p>
                    </div>
                  </div>
                </div>

                <div className="prose prose-lg max-w-none">
                  <h3 className="text-2xl font-bold text-black mb-4">Localização</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    O projeto está localizado em {projeto.localizacao}, uma das regiões mais valorizadas da Flórida, com excelente infraestrutura, acesso facilitado e alta demanda no mercado imobiliário.
                  </p>
                </div>
              </div>

              <div className="lg:col-span-1">
                <div className="bg-gray-900 text-white rounded-2xl p-8 sticky top-24">
                  <h3 className="text-2xl font-bold mb-6">Informações de investimento</h3>
                  
                  <div className="space-y-6 mb-8">
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Investimento mínimo</p>
                      <p className="text-3xl font-bold text-gold-500">{projeto.investimentoMinimo}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Retorno estimado</p>
                      <p className="text-3xl font-bold text-gold-500">{projeto.retornoEstimado}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Prazo</p>
                      <p className="text-2xl font-bold">{projeto.prazo}</p>
                    </div>
                  </div>

                  <div className="border-t border-gray-700 pt-6 mb-8">
                    <p className="text-xs text-gray-400 italic leading-relaxed">
                      Retornos estimados não são garantidos. Todo investimento envolve riscos.
                    </p>
                  </div>

                  <Link
                    to="/investir"
                    className="block w-full py-4 bg-gold-500 text-gray-900 text-center font-bold rounded-full hover:bg-gold-400 transition-all mb-4 whitespace-nowrap"
                  >
                    Quero participar desse projeto
                  </Link>

                  <a
                    href="https://wa.me/5511999999999"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full py-4 border-2 border-white text-white text-center font-semibold rounded-full hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
                  >
                    Falar no WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
